module.exports = __webpack_public_path__ + "images/saaremaa/favicon-32x32.png";